export default __webpack_public_path__ + "static/media/bg.98d6c098.svg";